export const Types = {
  NOVEDADES_LOADING: "NOVEDADES_LOADING",
  NOVEDADES_GET_REQUEST: "NOVEDADES_GET_REQUEST",
  NOVEDADES_GET_SUCCEEDED: "NOVEDADES_GET_SUCCEEDED",
  NOVEDADES_GET_ERROR: "NOVEDADES_GET_ERROR",

  NOVEDADES_GET_MENU_REQUEST: "NOVEDADES_GET_MENU_REQUEST",
  NOVEDADES_GET_MENU_SUCCEEDED: "NOVEDADES_GET_MENU_SUCCEEDED",
  NOVEDADES_GET_MENU_ERROR: "NOVEDADES_GET_MENU_ERROR",

  NOVEDADES_MARCAR_LEIDO: "NOVEDADES_MARCAR_LEIDO",
  MARCAR_NOVEDAD_LEIDA_SUCCESS: "MARCAR_NOVEDAD_LEIDA_SUCCESS",
};

export const startLoading = () => ({ type: Types.NOVEDADES_LOADING });

export const getNovedadesByClienteId = (clienteId, contactoId) => ({
  type: Types.NOVEDADES_GET_REQUEST,
  clienteId,
  contactoId,
});
export const getNovedadesByClienteIdSucceeded = (novedades) => ({
  type: Types.NOVEDADES_GET_SUCCEEDED,
  novedades,
});
export const getNovedadesByClienteIdError = (err) => ({
  type: Types.NOVEDADES_GET_ERROR,
  err,
});

export const getNovedadesMenuByClienteId = (clienteId, contactoId) => ({
  type: Types.NOVEDADES_GET_MENU_REQUEST,
  clienteId,
  contactoId,
});
export const getNovedadesMenuByClienteIdSucceeded = (novedades_menu) => ({
  type: Types.NOVEDADES_GET_MENU_SUCCEEDED,
  novedades_menu,
});
export const getNovedadesMenuByClienteIdError = (err) => ({
  type: Types.NOVEDADES_GET_MENU_ERROR,
  err,
});

export const marcarNovedadComoLeida = ({
  clienteId,
  contactoId,
  novedadId,
}) => ({
  type: Types.NOVEDADES_MARCAR_LEIDO,
  clienteId,
  contactoId,
  novedadId,
});
export const marcarNovedadComoLeidaSuccess = () => ({
  type: Types.MARCAR_NOVEDAD_LEIDA_SUCCESS,
});
